import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import App from './App';
import { ConfirmRoot } from './utils/confirm';
import API_BASE_URL from './config';
import logger from './utils/logger';

// Set axios base URL
axios.defaults.baseURL = API_BASE_URL;

// Debug: Log the API base URL
logger.log('🔧 API_BASE_URL:', API_BASE_URL);
logger.log('🌐 Current hostname:', window.location.hostname);

// Add axios interceptor to include auth token and tenant ID
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add tenant ID from localStorage (set by TenantContext)
    const tenantId = localStorage.getItem('currentTenantId');
    if (tenantId) {
      config.headers['X-Tenant-ID'] = tenantId;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Surface read-only demo blocks (403 + { demo: true }) as a friendly toast.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403 && error.response.data && error.response.data.demo) {
      const message = error.response.data.error || 'Демо режим — менувањето е оневозможено.';
      // Pages read the failure off different keys (.error here, .message there);
      // demoGuard only sends `error`, so Users.js fell back to a generic red
      // "Грешка при креирање". Fill both so whatever a page shows is the truth.
      error.response.data.message = message;
      // A stable toastId collapses repeat clicks into one toast instead of stacking.
      toast.info(message, { icon: '🔒', toastId: 'demo-readonly' });
    }
    return Promise.reject(error);
  }
);

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
        <ConfirmRoot />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
















